import { useTheme } from "@/components/theme-provider";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/cn";
import { icons } from "lucide-react";

interface FeaturesProps {
  icon: string;
  title: string;
  description: string;
}

const featureList: FeaturesProps[] = [
  {
    icon: "Calculator",
    title: "Point of Sale (POS)",
    description: "Handle payments with integrated mobile payment options.",
  },
  {
    icon: "WashingMachine",
    title: "Custom Service Management",
    description: "Personalize services to match your business needs.",
  },
  {
    icon: "CalendarArrowUp",
    title: "Order Management",
    description:
      "Track orders seamlessly from start to finish with an easy-to-use dashboard.",
  },

  {
    icon: "UserPen",
    title: "Employee Management",
    description: "Manage employee tasks, performance, and schedules.",
  },
  {
    icon: "ChartLine",
    title: "Business Analytics & Reports",
    description:
      "Gain insights into revenue, service popularity, and customer trends through powerful analytics.",
  },
  {
    icon: "Cctv",
    title: "Automated License Plate Recognition",
    description:
      "Speed up check-ins with quick and accurate vehicle identification.",
  },
];

export const FeaturesSection = () => {
  const { theme } = useTheme();
  return (
    <section
      id="product"
      className="container py-24 sm:py-32 overflow-x-hidden"
    >
      <h2 className="text-lg text-primary text-center mb-2 tracking-wider">
        Product
      </h2>

      <h2 className="text-3xl md:text-4xl text-center font-bold mb-4">
        What MikroSell Carwash POS offers
      </h2>

      <h3 className="md:w-1/2 mx-auto text-xl text-center text-muted-foreground mb-8">
        Unlock Efficiency and Streamline Operations
      </h3>

      <div className={`grid sm:grid-cols-2 lg:grid-cols-3 gap-4`}>
        {featureList.map(({ icon, title, description }) => (
          <div key={title}>
            <Card
              className={cn(
                `h-full bg-muted/50 dark:bg-card card`,
              )}
            >
             
              <CardHeader className="flex justify-center items-center">
                <div className="bg-primary/20 p-2 rounded-full ring-8 ring-primary/10 mb-4">
                  <Icon
                    name={icon as keyof typeof icons}
                    size={24}
                    color="hsl(var(--primary))"
                    className="text-primary"
                  />
                </div>

                <CardTitle className="text-center">{title}</CardTitle>
              </CardHeader>

              <CardContent className="text-muted-foreground text-center">
                {description}
              </CardContent>
            </Card>
            {/* <PixelCanvasDemo/> */}
          </div>
        ))}
      </div>
    </section>
  );
};


